import Bugsnag from "@bugsnag/js";
import { Capacitor } from "@capacitor/core";
import type { ClientInit, HandleClientError } from "@sveltejs/kit";
import { startBugsnag } from "$lib/bugsnag";
import i18n, { initializeI18next } from "$lib/i18n";
import { initFontSizeZoom } from "$lib/native/text-zoom";
import { darkMode } from "$lib/prefs.svelte";
import { registerServiceWorker, unregisterServiceWorker } from "$lib/sw.svelte";

/** Runs once, before the app renders. */
export const init: ClientInit = async () => {
  await startBugsnag();

  if (Capacitor.isNativePlatform()) {
    // We do not need the service worker in the capacitor app since all the assets are fetched from the filesystem.
    unregisterServiceWorker();
  } else {
    registerServiceWorker();
  }

  await initializeI18next();
  // Screen readers (and fallbacks such as it-CH -> it) rely on the detected language, not a hardcoded one.
  document.documentElement.lang = i18n.language;

  await initFontSizeZoom();

  // So the first paint already has the right theme.
  await darkMode.ready;
};

export const handleError: HandleClientError = ({ error, status, message }) => {
  // Unknown routes render the error page; they aren't bugs.
  if (status !== 404) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)));
  }
  return { message };
};
